import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { BaseBannerModel, BannerHotelDealModel } from 'app/model/banner/banner';
import { BannerDisplayModel } from 'app/model/banner/banner-display';
import { ActHttpService, HeaderTypes } from 'app/services/act-http/act-http.service';
import { UtilitiesService } from 'app/services/utilities/utilities.service';
import { environment } from 'environments/environment';
import * as moment from 'moment';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';

@Injectable()
export class BannerService {

  constructor(
    private actHttp: ActHttpService,
    private utilities: UtilitiesService,
  ) { }

  getBannerHotelDealList(companyId, lang, isMobile): Observable<BannerHotelDealModel[]> {
    const device = isMobile ? 'mobile' : 'desktop';
    const url = `${environment.endpoint.getBannerHotelDealList}` + `?companyId=${companyId}` + `&lang=${lang}` + `&device=${device}` ;
    return this.actHttp.get(url, this.actHttp.getRequestOptions(HeaderTypes.ACT_TOKEN))
      .map((res: Response) => res.json().data);
  }

  transformToDisplayBanner(banners: BannerHotelDealModel[]): BannerDisplayModel[] {
    const bannerDisplays: BannerDisplayModel[] = [];
    const formatFullDate = 'YYYY-MM-DD';
    const formatDisplayDate = 'D MMM YY';
    const formatDisplayDateNotYear = 'D MMM';

    banners.forEach(banner => {
      let display = {
        bannerId: banner.bannerId,
        title: banner.title,
        bookPeriodFrom: banner.bookPeriodFrom,
        bookPeriodTo: banner.bookPeriodTo,
        stayPeriodFrom: banner.stayPeriodFrom,
        stayPeriodTo: banner.stayPeriodTo,
        fileUrl: banner.fileUrl,
        description: banner.description,
        link: banner.link,
        altText: banner.altText
      } as BannerDisplayModel;

      const isSameYearBook = this.checkSameYear(banner.bookPeriodFrom, banner.bookPeriodTo);
      const isSameYearStay = this.checkSameYear(banner.stayPeriodFrom, banner.stayPeriodTo);

      display.displayBookStart = this.utilities.convertDateFormat(banner.bookPeriodFrom, formatFullDate, isSameYearBook ? formatDisplayDateNotYear : formatDisplayDate);
      display.displayBookEnd = this.utilities.convertDateFormat(banner.bookPeriodTo, formatFullDate, formatDisplayDate);
      display.displayStayStart = this.utilities.convertDateFormat(banner.stayPeriodFrom, formatFullDate, isSameYearStay ? formatDisplayDateNotYear : formatDisplayDate);
      display.displayStayEnd = this.utilities.convertDateFormat(banner.stayPeriodTo, formatFullDate, formatDisplayDate);

      bannerDisplays.push(display);
    });

    return bannerDisplays;
  }

  checkSameYear(start, end): boolean {
    const startYear = moment(start, 'YYYY-MM-DD', 'en').year();
    const endYear = moment(end, 'YYYY-MM-DD', 'en').year();
    return startYear === endYear;
  }

  getBannerBillboard(companyId: number, lang: string, device: string): Observable<BaseBannerModel[]> {
    const params = new URLSearchParams();
    params.append('companyId', `${companyId}`);
    params.append('lang', lang);
    params.append('device', device);
    const url = `${environment.endpoint.getBannerBillboard}?${params}`;
    return this.actHttp.get(url, this.actHttp.getRequestOptions(HeaderTypes.ACT_TOKEN))
      .map((res: Response) => res.json().data);
  }

  getBannerOverlay(companyId: number, lang: string, device: string): Observable<BaseBannerModel[]> {
    const params = new URLSearchParams();
    params.append('companyId', `${companyId}`);
    params.append('lang', lang);
    params.append('device', device);
    const url = `${environment.endpoint.getBannerOverlay}?${params}`;
    return this.actHttp.get(url, this.actHttp.getRequestOptions(HeaderTypes.ACT_TOKEN))
      .map((res: Response) => res.json().data);
  }

  getBannerLeaderboard(companyId: number, lang: string, device: string): Observable<BaseBannerModel[]> {
    const params = new URLSearchParams();
    params.append('companyId', `${companyId}`);
    params.append('lang', lang);
    params.append('device', device);
    const url = `${environment.endpoint.getBannerLeaderboard}?${params}`;
    return this.actHttp.get(url, this.actHttp.getRequestOptions(HeaderTypes.ACT_TOKEN))
      .map((res: Response) => res.json().data);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/banner/banner.service.ts